import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';
import EncumbrancesTable from 'modules/partners/components/EncumbrancesTable';
import { EncumbrancesTableProvider } from 'modules/partners/components/EncumbrancesTable/context/EncumbrancesTableContext';

import { useShareDetailsPage } from '../context/ShareDetailsPageContext';
import EncumbrancesHeader from './EncumbrancesHeader';

const EncumbrancesSection: FC = () => {
  const { data, actions } = useShareDetailsPage();

  const showPagination = data.encumbrances && data.encumbrancesTotal > 10;

  return (
    <div>
      <EncumbrancesHeader />

      <EncumbrancesTableProvider
        encumbrances={data.encumbrances}
        expandedRows={data.expandedRows}
        isAdmin={data.isAdmin}
        isReadOnly={data.isReadOnly}
        handleToggleRowExpansion={actions.handleToggleRowExpansion}
        handleViewEncumbrance={actions.handleViewEncumbrance}
        handleEditEncumbrance={actions.handleEditEncumbrance}
        handleRemoveEncumbrance={actions.handleRemoveEncumbrance}
      >
        <EncumbrancesTable />
      </EncumbrancesTableProvider>

      {showPagination && (
        <TablePagination
          totalRows={data.encumbrancesTotal}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default EncumbrancesSection;
